export default "__VITE_ASSET__RCw6dxJ3__"